"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.omit = void 0;
function omit(source, ...keys) {
    const auxKeys = keys.map((key) => (typeof key === 'number' ? key.toString() : key));
    const result = {};
    for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key) && !auxKeys.includes(key)) {
            result[key] = source[key];
        }
    }
    return result;
}
exports.omit = omit;
//# sourceMappingURL=#omit.js.map